import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';

export const adminClaimRelaunchPlanNewRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/claim_relaunch_plans/new',
}).lazy(() =>
  import(
    'pages/admin/ClaimRelaunchPlans/AdminClaimRelaunchPlanNewPage/AdminClaimRelaunchPlanNewPage'
  ).then((d) => d.Route)
);
